"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SplitProvider_1 = require("./SplitProvider");
exports.useTrack = function () {
    var _a = react_1.useContext(SplitProvider_1.SplitContext), client = _a.client, isReady = _a.isReady;
    return client && isReady ? client.track.bind(client) : defaultTrack;
};
var defaultTrack = function () { return false; };
//# sourceMappingURL=useTrack.js.map